import type { IconSvgObject } from './types';

const FileKeyIcon: IconSvgObject = [
  ["path", { d: "M4.5 14V4C4.5 2.89543 5.39543 2 6.5 2H13.5L20.5 9V20C20.5 21.1046 19.6046 22 18.5 22H11.5", stroke: "currentColor", strokeLinecap: "round", strokeLinejoin: "round", strokeWidth: "1.5", key: "0" }],
  ["path", { d: "M13.5 2V7C13.5 8.10457 14.3954 9 15.5 9H20.5", stroke: "currentColor", strokeLinecap: "round", strokeLinejoin: "round", strokeWidth: "1.5", key: "1" }],
  ["path", { d: "M7 18.5L11.5 14M10.5 15.5L11.5 16.5M7.5 20C7.5 21.1046 6.60457 22 5.5 22C4.39543 22 3.5 21.1046 3.5 20C3.5 18.8954 4.39543 18 5.5 18C6.60457 18 7.5 18.8954 7.5 20Z", stroke: "currentColor", strokeLinecap: "round", strokeLinejoin: "round", strokeWidth: "1.5", key: "2" }]
];

export default FileKeyIcon;
